<div class="overlay"></div>
<div class="container">
    <div class="img-wrapper">
        <img src="assets/icons/laptop-red.svg" [alt]="'settings.LAPTOP' | transloco" />
        <img src="assets/icons/sad-face-emote-red.svg" [alt]="'settings.SAD_EMOTE_FACE' | transloco" />
    </div>
    <div>
        <h3>{{'settings.GRANT_BROWSER_ACCESS' | transloco}}</h3>
        <h4>
            {{'settings.USING_IPAD' | transloco}} <span>{{'settings.SETTINGS' | transloco}}</span> >
            <span>{{'settings.PRIVACY_AND_SECURITY' | transloco}}</span> >
            <span>{{'settings.SPEECH_RECOGNITION' | transloco}}</span>.
            <br />
            {{'settings.GRANT_ACCESS_REFRESH' | transloco}}
        </h4>
    </div>
    <button (click)="refreshPage()">{{'settings.REFRESH_PAGE' | transloco}}</button>
</div>